/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Sales_Range_TitleInputs */

const en_cargos_sales_range_title = /** @type {(inputs: Cargos_Sales_Range_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bags sold by cargo`)
};

const es_cargos_sales_range_title = /** @type {(inputs: Cargos_Sales_Range_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sacos vendidos por carga`)
};

/**
* | output |
* | --- |
* | "Bags sold by cargo" |
*
* @param {Cargos_Sales_Range_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_sales_range_title = /** @type {((inputs?: Cargos_Sales_Range_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Sales_Range_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_sales_range_title(inputs)
	return es_cargos_sales_range_title(inputs)
});